export default "__VITE_ASSET__Dl290HXG__"